import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/pro-solid-svg-icons';

const RemoveControl = ({ ariaLabel, iconSize, onClick }) => (
  <FontAwesomeIcon
    aria-label={ariaLabel}
    className="clickable"
    icon={faTrash}
    size={iconSize}
    onClick={onClick}
  />
);

RemoveControl.propTypes = {
  ariaLabel: PropTypes.string,
  iconSize: PropTypes.string,
  onClick: PropTypes.func.isRequired
};

export default RemoveControl;
